exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-ddae7db4]{font-weight:700;color:var(--dark-color)}.uploadBtn[data-v-ddae7db4]{border:1px solid var(--dark-color);color:var(--dark-color)}.uploadBtn[data-v-ddae7db4]:hover{background-color:var(--dark-color);color:var(--white-color)}.test[data-v-ddae7db4]{display:none}@media (min-width:1200px){.test[data-v-ddae7db4]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddae7db4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/awards/CreateAward.vue
// module id = 364
// module chunks = 0